<template>
    <div>
        <vs-row>
            <vs-col vs-align="left" vs-w="6">
                
                <vs-button
                    v-if="can('create', 'campaigns')"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="() => showPopupExpress = true"
                >
                    Ajout express
                </vs-button>

                <vs-button
                    v-if="can('create', 'campaigns')"
                    class="ml-5"
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="showFormCreate"
                >
                    Ajouter une nouvelle question
                </vs-button>

                <DialogPrompt
                    :active.sync="showPopupExpress"
                    title="Ajout express"
                    cancel-text="Fermer"
                    accept-text="Créer les questions"
                    button-accept="filled"
                    :is-valid="!formExpressError"
                    @cancel="() => resourcesExpress = []"
                    @close="() => resourcesExpress = []"
                    @accept="saveResourcesExpress"
                >
                    <QuestionExpressForm 
                        v-model="resourcesExpress"
                        @error="(formErr) => formExpressError = formErr"
                    />
                </DialogPrompt>

                <DialogPrompt
                    :active.sync="showPopup"
                    :title="getDataPrompt.title"
                    cancel-text="Annuler"
                    accept-text="Enregistrer"
                    :button-accept="getDataPrompt.btnAccept"
                    :is-valid="!formError"
                    @cancel="resetResource"
                    @close="resetResource"
                    @accept="saveResource"
                >
                     <QuestionForm
                        v-model="resource"
                        :type="formType"
                        @error="setFormError"
                    />
                </DialogPrompt>

            </vs-col>
            <vs-col vs-type="flex" vs-align="left" vs-w="6" />
        </vs-row>

        <vs-table
            :sst="true"
            @search="eventSearchItems"
            @sort="eventSortByCol"
            search
            :no-data-text="loading ? `Chargement de vos données...` : `Aucune donnée à afficher`"
            style="width:100%"
            :data="itemsData"
            :loading="true"
            >
            <template slot="thead">
                <vs-th>
                    <Sort 
                        name="title" 
                        :value="apiParams.sortBy.title"
                        @sort="eventSortByCol" 
                    >
                        Libellé
                    </Sort>
                </vs-th>
                <vs-th>
                    <Sort 
                        name="type" 
                        :value="apiParams.sortBy.type"
                        @sort="eventSortByCol" 
                    >
                        Type
                    </Sort>
                </vs-th>
                <vs-th>
                    <Sort 
                        name="updated_at" 
                        :value="apiParams.sortBy.updated_at"
                        @sort="eventSortByCol" 
                    >
                        Modifier le
                    </Sort>
                </vs-th>
                <vs-th></vs-th>
            </template>

            <template>
                <vs-tr v-for="(item, i) in items.data" :key="i">
                    <vs-td>
                        {{ get(item, ':title') }}
                        <Speaker 
                            v-if="item.audio_description && isASuperAdmin()" 
                            class="ml-2" 
                            :url="item.audio_description"
                        />
                    </vs-td>
                    <vs-td>
                        {{ get(item, ':type') }}
                    </vs-td>
                    <vs-td>
                        {{ localeDateTime(get(item, ':updated_at')) }}
                    </vs-td>
                    <vs-td class="action">
                        <div class="action-wrapper">
                            <vs-button
                                v-if="can('update', 'services', item.id)"

                                v-tooltip="'Modifier'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-edit"
                                @click.stop="showFormUpdate(item)"
                            />

                            <vs-button
                                v-if="can('delete', 'services', item.id)"
                                v-tooltip="'Supprimer'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-trash"
                                @click.stop="removeResource(item)"
                            />
                        </div>
                    </vs-td>
                </vs-tr>
            </template>

        </vs-table>

        <vs-row>
            <vs-col class="mt-4" v-if="items.total > 0">
                <vs-pagination :total="Math.ceil(items.total / apiParams.perpage)" v-model="currentPage"></vs-pagination>
            </vs-col>
        </vs-row>
    </div>

</template>

<script>

import QuestionForm from '@components/views/rh/referentiel/questions/QuestionForm';
import QuestionExpressForm from '@components/views/rh/referentiel/questions/QuestionExpressForm';
import { localeDateTime } from "@assets/utils/helpers/helpers.js";

export default {
    name: 'Questions',
    components: {
        QuestionForm,
        QuestionExpressForm
    },
    props: {
        api: {
            type: String
        },
        perpage: {
            type: String
        }
    },
    data() {
        return {
            log: console.log,
            localeDateTime,
            config: [],
            currentPage: 1,
            loading: false,
            showPopup: false,
            showPopupExpress: false,
            resource: {
                id: null,
                title: null,
                type: null,
                description: null,
                levels: {
                    level_0: null,
                    level_1: null,
                    level_2: null,
                    level_3: null,
                },
                audio_description: null,
                photo: null,
            },
            resourcesExpress: {},
            formExpressError: true,
            formError: true,
            formType: "create",
            prompt: {
                show: {
                    title: 'Consulter une question',
                    btnAccept: 'false'
                },
                create: {
                    title: 'Ajouter une question',
                    btnAccept: 'filled'
                },
                update: {
                    title: 'Modifier une question existante',
                    btnAccept: 'filled'
                }
            }
        }
    },

    watch: {
        loading(value) {
            if (value) {
                this.$vs.loading()
            } else {
                this.$vs.loading.close()
            }
        }
    },

    computed: {
        getDataPrompt() {
            switch(this.formType) {
                case 'show':
                    return this.prompt.show
                    break;
                case 'create':
                    return this.prompt.create
                    break;
                case 'update':
                    return this.prompt.update
                    break;
                default:
                    return this.prompt.show
            }
        },
    },

    methods: {
        showFormCreate() {
            this.resetResource();
            this.formType = "create";
            this.showPopupExpress = true;
        },

        showFormCreate() {
            this.resetResource();
            this.formType = "create";
            this.showPopup = true
        },

        showFormUpdate(resource) {
            this.setResource(resource);
            this.formType = "update";
            this.showPopup = true
        },

        saveResource() {
            let data = window._.cloneDeep(this.resource)

            if (data.id) {
                this.apiUpdate(
                    data, 
                    data.id,
                    (resp) => this.loadItems(),
                    (err)  => this.showPopup = true,
                    {'Content-Type': 'multipart/form-data'}
                );
            } else {
                this.apiCreate(
                    data,
                    (resp) => this.loadItems(),
                    (err)  => this.showPopup = true,
                    {'Content-Type': 'multipart/form-data'}
                );
            }
        },

        saveResourcesExpress() {

            const questions = this.resourcesExpress.questions.map(q => ({title: q.title, type: q.type.id}))

            window.axios({
                method: 'post',
                url: '/api/referentiel/questions/express',
                data: {questions: questions},
            })
            .then(response => {
                let url;

                if (response.status === 200 && response.data != '') {
                    this.notifySuccess('Succès', 'Élements ajoutés avec succès !')
                } else {
                    this.notifyError('Erreur', `Une erreur est survenue lors de la création`)
                }

                if (this.resourcesExpress.questionOnly == 1) {
                    this.loadItems();
                } else {
                    
                    // Créer un bloc associé
                    const ids = response.data.map(item => item.id);
                    url = `${document.location.origin}/rh/referentiel/blocs?create=true&questions=${ids}`;
                    document.location.href = url;
                }

            })
            .catch((err) => {
                this.showPopupExpress = true
                this.notifyErrorValidation(err)
            })
        },

        removeResource(resource) {
            this.apiDelete(resource.id, () => this.loadItems());
        },

        setResource(data) {
            this.resource = JSON.parse(JSON.stringify(data));
        },

        resetResource() {
            this.resource = {
                id: null,
                title: null,
                type: null,
                description: null,
                levels: {
                    level_0: null,
                    level_1: null,
                    level_2: null,
                    level_3: null,
                },
                photo: null,
                photo_blob: null,
                audio_description: null,
                audio_description_blob: null
            }
        },

        setFormError (value) {
            this.formError = value;
        },

    },
    created() {
        this.apiParams.include = [];
        this.apiParams.sortBy = {updated_at: "desc"}
        this.loadItems();
    }
}
</script>
